// Referral Management Types

export enum SourcingChannel {
  VENDOR_REFERRAL = "VENDOR_REFERRAL",
  TELECALLER = "TELECALLER",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  WEBSITE = "WEBSITE",
  WALK_IN = "WALK_IN",
  OTHER = "OTHER",
}

export enum ReferralStatus {
  LEAD_CREATED = "LEAD_CREATED",
  CONTACTED = "CONTACTED",
  REGISTERED = "REGISTERED",
  KYC_VERIFIED = "KYC_VERIFIED",
  FIRST_DELIVERY_COMPLETED = "FIRST_DELIVERY_COMPLETED",
  ACTIVE = "ACTIVE",
  RETAINED_30 = "RETAINED_30",
  RETAINED_90 = "RETAINED_90",
  CHURNED = "CHURNED",
  REJECTED = "REJECTED",
}

export interface RiderReferral {
  id: string;
  referralCode: string;
  candidateName: string;
  candidatePhone: string;
  candidateEmail?: string;
  city: string;
  sourcingChannel: SourcingChannel;
  vendorId?: string;
  vendor?: {
    id: string;
    vendorCode: string;
    name: string;
    phone: string;
  };
  telecallerId?: string;
  telecaller?: {
    id: string;
    telecallerCode: string;
    name: string;
    phone: string;
  };
  riderId?: string;
  status: ReferralStatus;
  leadCreatedAt: Date;
  contactedAt?: Date;
  registeredAt?: Date;
  kycVerifiedAt?: Date;
  firstDeliveryAt?: Date;
  activeAt?: Date;
  retained30At?: Date;
  retained90At?: Date;
  churnedAt?: Date;
  rejectedAt?: Date;
  rejectionReason?: string;
  notes?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateReferralDTO {
  candidateName: string;
  candidatePhone: string;
  candidateEmail?: string;
  city: string;
  sourcingChannel: SourcingChannel;
  vendorId?: string;
  telecallerId?: string;
  notes?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
}

export interface ReferralFilterParams {
  page?: number;
  limit?: number;
  status?: ReferralStatus;
  sourcingChannel?: SourcingChannel;
  vendorId?: string;
  telecallerId?: string;
  city?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}

export interface ReferralFunnel {
  total: number;
  leadCreated: number;
  contacted: number;
  registered: number;
  kycVerified: number;
  firstDelivery: number;
  active: number;
  retained30: number;
  retained90: number;
  churned: number;
  rejected: number;
  conversionRates: {
    leadToRegistered: number;
    registeredToKyc: number;
    kycToFirstDelivery: number;
    firstDeliveryToActive: number;
    activeToRetained30: number;
    retained30ToRetained90: number;
  };
  averageTimeToConversion: {
    leadToRegistered: number; // in hours
    registeredToKyc: number;
    kycToFirstDelivery: number;
  };
}

export interface ReferralTimeline {
  referralId: string;
  events: Array<{
    status: ReferralStatus;
    timestamp: Date;
    notes?: string;
  }>;
}
